import { render, staticRenderFns } from "./CuttingOverview.vue?vue&type=template&id=60115278"
import script from "./CuttingOverview.vue?vue&type=script&lang=js"
export * from "./CuttingOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports